'use strict'

/**
 * Module qui gère les transitions entre les deux formulaires connexion / inscription
 */

import tooltips from 'Modules/tooltips'
import ajaxLoader from 'Modules/ajaxLoader'

const J_SUBMIT_FORGOTTEN_PASSWORD = '.j_submit_forgottenPassword'
const J_DATA_ACTION_RECOVER_PASSWORD = 'action'
const J_FORGOTTEN_PASSWORD_RESULT_LOCATION = '.j_forgottenPassword_result'
const C_HIDDEN = 'hidden'
const C_ERROR = 'has-error'
const C_SUCCESS = 'has-success'
const C_GREEN_CHECKED_ICON = 'icon-checkform-ok'
const J_BIRTHDAY_TOOLTIP = '.j_birthDay_tooltip'
const J_BIRTHDAY_TOOLTIP_PLACEMENT = 'placement'
const J_FORGOTTEN_PASSWORD_DIV_TO_HIDE = '.j_forgottenpassword_divToHide'

/*
 * Fonction AJAX de récupération du mot de passe. Utiliser dans la modal de récupération du mdp
 */
function recoverPassword(event) {
    const $form = $(event.target)
    const button = $form
        .find(J_SUBMIT_FORGOTTEN_PASSWORD + ':submit')
        .not(':hidden')
    const action = $(button).data(J_DATA_ACTION_RECOVER_PASSWORD)
    const parameters = $form.find(':input').not(':hidden').serializeArray()

    ajaxLoader.loadAndExecuteCallBack(
        'POST',
        parameters,
        function (content) {
            const $location = $(J_FORGOTTEN_PASSWORD_RESULT_LOCATION)
            if (content.Result === false) {
                $location.empty().append(content.Message)
                $location.removeClass(C_HIDDEN)
                $location.removeClass(C_SUCCESS)
                $location.removeClass(C_GREEN_CHECKED_ICON)
                $location.addClass(C_ERROR)
            } else {
                $location.append(content.Message)
                $location.removeClass(C_HIDDEN)
                $location.removeClass(C_ERROR)
                $(J_FORGOTTEN_PASSWORD_DIV_TO_HIDE).addClass(C_HIDDEN)
                $location.find('i').addClass(C_GREEN_CHECKED_ICON)
            }
        },
        function () {
            // En cas d'échec on affiche une erreur
            const $location = $(J_FORGOTTEN_PASSWORD_RESULT_LOCATION)
            $location.removeClass(C_HIDDEN)
            $location.removeClass(C_SUCCESS)
            $location.addClass(C_ERROR)
            $location.empty().append($t('_500'))
        },
        action
    )

    return false
}

/*
 * Gestion de la tooltip sur le champ birthday
 */
function setEventToolTipsOnBirthDay() {
    const $location = $(J_BIRTHDAY_TOOLTIP)

    $location.on('mouseenter', function (event) {
        if ($(event.currentTarget) !== undefined) {
            tooltips.setEventOnItem(
                $(event.currentTarget),
                $(event.currentTarget).data(J_BIRTHDAY_TOOLTIP_PLACEMENT),
                $t('EN_RENSEIGNANT_DATE_ANNIVERSAIRE')
            )
        }
    })
    $location.on('mouseleave', function (event) {
        if ($(event.currentTarget) !== undefined) {
            tooltips.hideToolTip($(event.currentTarget))
        }
    })
}

export default {
    recoverPassword: recoverPassword,
    setEventToolTipsOnBirthDay: setEventToolTipsOnBirthDay
}
